import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2073b1ad&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2073b1ad&rel=stylesheet%2Fscss&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=2073b1ad&scoped=true&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2073b1ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2073b1ad')) {
      api.createRecord('2073b1ad', component.options)
    } else {
      api.reload('2073b1ad', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2073b1ad&scoped=true", function () {
      api.rerender('2073b1ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataprivilegerules/index.vue"
export default component.exports